import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import * as EmailValidator from 'email-validator';
import { NgxPermissionsObject, NgxPermissionsService } from 'ngx-permissions';

import { UserRolesModel, UserModel, SentInvitationModel } from '@models/index';
import { emptyUserModel } from '@utilities/data-utils';

@Component({
  selector: 'app-autocomplete-user',
  templateUrl: './autocomplete-user.component.html',
  styleUrls: ['./autocomplete-user.component.sass']
})
export class AutocompleteUserComponent implements OnChanges, OnInit {
  @Input() topicTittle: string;
  @Input() userRoles: UserRolesModel[];
  @Input() searchUsersList: UserModel[];
  @Output() searchQuery = new EventEmitter<string>();
  @Output() sendInvitationUser = new EventEmitter<SentInvitationModel>();
  @Output() addRoleToUser = new EventEmitter<{ user: UserModel, role: UserRolesModel }>();
  selectedUserQuery: UserModel = emptyUserModel();
  selectedRoleModel: UserRolesModel;
  searchQueryText: string;  
  firstName: string;  
  lastName: string;
  email: string = '';

  isAddButtonEnabled: boolean = false;
  isAddButtonShown: boolean = false;
  isSendButtonEnabled: boolean = false;
  isSendButtonShown: boolean = false;

  permissions: NgxPermissionsObject;

  constructor(
    private permissionsService: NgxPermissionsService
  ) {}

  ngOnInit() {
    this.permissions = this.permissionsService.getPermissions()
  }

  ngOnChanges(changes: SimpleChanges) {
    const { email, searchUsersList, selectedRoleModel, selectedUserQuery } = changes;

    if (false
      || (email && email.previousValue != this.email)
      || (searchUsersList && searchUsersList.previousValue != this.searchUsersList)
      || (selectedRoleModel && selectedRoleModel.previousValue != this.selectedRoleModel)
      || (selectedUserQuery && selectedUserQuery.previousValue != this.selectedUserQuery)
    ) {
      this.updateState();
    }
  }

  updateState() {
    const validEmail = EmailValidator.validate(this.email);

    this.isAddButtonEnabled = !!this.selectedUserQuery && !!this.selectedRoleModel;
    this.isAddButtonShown = validEmail && this.searchUsersList.length > 0;
    this.isSendButtonEnabled = !!this.selectedRoleModel;
    this.isSendButtonShown = validEmail && this.searchUsersList.length === 0;
  }

  queryChange(_event) {
    if (EmailValidator.validate(this.email)) {
      this.searchQuery.emit(this.email)
    }
  }

  addRoleToUserToBusiness() {
    this.addRoleToUser.emit({ user: this.searchUsersList[0], role: this.selectedRoleModel })
    this.selectedUserQuery = emptyUserModel()
    this.selectedRoleModel = null
    this.email = ''
  }

  sendInvitation() {
    this.sendInvitationUser.emit({
      email: this.email,
      firstName: this.firstName,
      lastName: this.lastName,
      role: this.selectedRoleModel,
    });
    this.searchQueryText = '';
    this.selectedUserQuery = emptyUserModel();
    this.selectedRoleModel = null;
    this.email = '';
  }
}
